import { LOGIN_CUSTOMER_AFTER_REGISTER } from "../actions/env.action";

const initialState = {
  qrCodeImg: null,
  createdCustomer: null,
  isEmailSent: false,
  isPrivacyGiftReceived: false,
  isPrivacyGift: false,
};

const thankyou = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_CUSTOMER_AFTER_REGISTER:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default thankyou;
